import { render, staticRenderFns } from "./PageSizeSelect.vue?vue&type=template&id=6c040ac3&scoped=true"
import script from "./PageSizeSelect.ts?vue&type=script&lang=ts&external"
export * from "./PageSizeSelect.ts?vue&type=script&lang=ts&external"
import style0 from "./PageSizeSelect.vue?vue&type=style&index=0&id=6c040ac3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c040ac3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c040ac3')) {
      api.createRecord('6c040ac3', component.options)
    } else {
      api.reload('6c040ac3', component.options)
    }
    module.hot.accept("./PageSizeSelect.vue?vue&type=template&id=6c040ac3&scoped=true", function () {
      api.rerender('6c040ac3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Bills/components/list/PageSizeSelect/PageSizeSelect.vue"
export default component.exports